export enum ShareResourceEnum {
  'share-funnel' = 'share-funnel',
  'share-blog' = 'share-blog',
  'share-newsletter' = 'share-newsletter',
  'share-campaign' = 'share-campaign',
  'share-course' = 'share-membership-course',

  Funnel = 'funnel',
  Blog = 'blog',
  Newsletter = 'newsletter',
  Campaign = 'campaign',
  Course = 'course',
  UserBlock = 'user-block',
  MasterBlock = 'master-block',
  Workflow = 'Workflow',
}
